query CardAccounts(
  $filter: CardAccountFilter
  $orderBy: [CardAccountsOrderBy!]
) {
  cardAccounts(filter: $filter, orderBy: $orderBy) {
    nodes {
      id
      name
      description
      businessUnitId
      businessUnits {
        name
      }
      _isTagsExist
      _isNotesExist
      _isUpdatable
      _rowTimestamp
      documentPoolId
      documentPools {
        name
      }
      companyCardCompanyId
      companyCardCompanies {
        cardCompanyId
        _isManualProcess
      }
      cardAccountTransactions(orderBy: TRANSACTION_DATE_DESC) {
        nodes {
          transactionDate
          description
          transactionType
          amount
          currencyId
          currency {
            isoCode
          }
        }
      }
      cardAccountHistoriesByEntityId {
        nodes {
          crudOperation
          tenantUserName
          pointInTimeDate
        }
      }
      cardHolders {
        totalCount
      }
    }
  }
}
